export const AUTO_APPROVAL_ACTION_MAPPING = {
    saveNewPreference: "saveNewPreference"
  }

export const BANNER_TYPE = {
  disableBanner: "diable",
  onBanner: "on",
  offBanner: "off"
}
  